import { Tabs as RadixTabs } from 'radix-ui';
import type { ComponentPropsWithRef } from 'react';
import { cn } from '../lib/cn';

export const Tabs = RadixTabs.Root;

export function TabsList({ className, ...props }: ComponentPropsWithRef<typeof RadixTabs.List>) {
  return <RadixTabs.List className={cn('flex items-center gap-0.5', className)} {...props} />;
}

export function TabsTrigger({
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixTabs.Trigger>) {
  return (
    <RadixTabs.Trigger
      className={cn(
        'h-7 rounded-md px-2.5 text-sm font-medium whitespace-nowrap text-text-3 transition-colors duration-100 outline-none',
        'hover:bg-bg-3 hover:text-text-1 focus-visible:ring-2 focus-visible:ring-focus',
        // Style from ARIA, not data-state: a wrapping Tooltip trigger overwrites data-state.
        'aria-selected:bg-bg-4 aria-selected:text-text-1',
        className,
      )}
      {...props}
    />
  );
}

export function TabsContent({
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixTabs.Content>) {
  return <RadixTabs.Content className={cn('outline-none', className)} {...props} />;
}
